import type { PersonNameChangeCommandData } from '@festina/legalentity-general-types/legalentity'
import { typeUtils } from '@festina-life/core'
import {
  FormikForm,
  FormikSelect,
  FormikTextInput,
} from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'

const validateKey = typeUtils.createValidator<PersonNameChangeCommandData>()

export const PersonNameChangeCommandDataForm = (
  props: CommandDataFormProps<PersonNameChangeCommandData>,
) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const informationSources = useHook('pages.crm.useCrmInformationSources')()

  return (
    <FormikForm
      initialValues={{
        _type: 'PersonNameChangeCommandData',
      }}
      {...props}
    >
      <FormikSelect
        name={validateKey('informationSource')}
        label={translate('card.field.informationSource')}
        options={informationSources}
        renderFn={(x) => translateEnum('legalEntity.enum.InformationSource', x)}
      />
      <FormikTextInput
        name={validateKey('personEntityName.firstName')}
        label={translate('nameChangeButton.firstName')}
      />
      <FormikTextInput
        name={validateKey('personEntityName.lastName')}
        label={translate('nameChangeButton.lastName')}
      />
    </FormikForm>
  )
}
